import {FileDirectoryFillIcon, FileIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps} from '@primer/react'

interface FileSuggestionProps extends ActionListItemProps {
  type: 'file' | 'folder'
  path: string
}

export function FileSuggestion({type, path, ...props}: FileSuggestionProps) {
  const parts = path.split('/')
  const name = parts.pop()!

  return (
    <ActionList.Item {...props}>
      <ActionList.LeadingVisual>
        {type === 'folder' ? <FileDirectoryFillIcon /> : <FileIcon />}
      </ActionList.LeadingVisual>
      {name}
      <ActionList.Description variant="inline">{parts.join('/')}/</ActionList.Description>
    </ActionList.Item>
  )
}

try{ FileSuggestion.displayName ||= 'FileSuggestion' } catch {}